
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[id]",
      function () {
        return require("private-next-pages/restaurants/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[id]"])
      });
    }
  